import { render, staticRenderFns } from "./ItemEmptyLink.vue?vue&type=template&id=f9897bbe&scoped=true&"
import script from "./ItemEmptyLink.vue?vue&type=script&lang=js&"
export * from "./ItemEmptyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9897bbe",
  null
  
)

export default component.exports